import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImageVersionService {
    private readonly __versions$$ = signal<Record<string, string>>({});
    readonly versions$$ = this.__versions$$.asReadonly();

    set(guid: string, version: string): void {
        this.__versions$$.update(v => ({ ...v, [guid]: version }));
    }
}
